import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { Meeting } from '../../meeting';
import { MeetingAttendeesService } from '../../meeting-attendee.service';
import * as MeetingAttendeesActions from './meeting-attendees.actions';


@Injectable()
export class MeetingAttendeesEffects {
  loadMeetingById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MeetingAttendeesActions.loadMeeting),
      filter(action => !!action.meetingId),
      switchMap(action => 
        this.meetingAttendeeService.getMeetingInformation(action.meetingId).pipe(
          map(meeting => MeetingAttendeesActions.loadMeetingSuccess({ meeting: meeting || new Meeting() })),
          catchError(error => of(MeetingAttendeesActions.loadMeetingFailure({ error })))
        )
      )
    )
  );

  loadMeetingByEmail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MeetingAttendeesActions.loadMeeting),
      filter(action => !!action.email),
      switchMap(action => 
        this.meetingAttendeeService.getMeetingIdByEmail(action.email).pipe(
          map(meeting => MeetingAttendeesActions.loadMeetingSuccess({ meeting: meeting || new Meeting() })),
          catchError(error => of(MeetingAttendeesActions.loadMeetingFailure({ error })))
        )
      )
    )
  );

  constructor(private actions$: Actions,
              private meetingAttendeeService: MeetingAttendeesService) {}
}
